/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A host group and its joining groups inside a combination window that is open now (#1586): children checked in now against the host group's capacity, and staff on shift now against the staffing model on the combined headcount.
 */
export type shifts_LiveUnitCoverageDTO = {
    combination_id: string;
    host_capacity: number | null;
    host_capacity_weighted: number | null;
    host_group_id: string;
    host_group_name: string;
    in_group_qualified_staff: number | null;
    /**
     * InGroupStaff and InGroupQualifiedStaff count the distinct employees in any group of
     * the unit by group presence (#2113); null when the switch is off. The split alert
     * reads the plan only.
     */
    in_group_staff: number | null;
    member_group_ids: Array<string>;
    member_group_names: Array<string>;
    /**
     * MinQualifiedStaff and ScheduledQualifiedStaff show a qualified-staff shortfall, which
     * raises SHORT_STAFF even when the unit has enough employees in total.
     */
    min_qualified_staff: number;
    over_capacity: boolean;
    present_children: number;
    present_weighted: number;
    reason: shifts_LiveUnitCoverageDTO.reason | null;
    required_staff: number;
    scheduled_qualified_staff: number;
    scheduled_staff: number;
    split_alert: boolean;
    window_end: string;
    window_start: string;
};
export namespace shifts_LiveUnitCoverageDTO {
    export enum reason {
        OVER_CAPACITY = 'OVER_CAPACITY',
        SHORT_STAFF = 'SHORT_STAFF',
        BOTH = 'BOTH',
    }
}

